import { jwtDecode } from "jwt-decode";

const STORAGE_KEY = "ROCP_idToken";

export const getToken = () => {
  const token = localStorage.getItem(STORAGE_KEY);
  return token?.replaceAll('"', "") ?? "";
};

// Total function: a missing OR malformed token yields null, never a throw, so
// every getter derived from it is safe to call from render paths. Callers that
// must not proceed without an identity go through utils/sessionGuard instead.
export const getDecodedToken = () => {
  const token = getToken();
  if (!token) return null;
  try {
    return jwtDecode(token);
  } catch {
    return null;
  }
};

export const getLoggedInUserId = () => {
  const decoded = getDecodedToken();
  return decoded ? Number(decoded["custom:userId"]) : null;
};

export const getLoggedInUserEmail = () => {
  const decoded = getDecodedToken();
  return decoded?.email ?? "";
};

export const getLoggedInUsername = () => {
  const decoded = getDecodedToken();
  return decoded?.["custom:username"] ?? "";
};
